import React from "react";
import { Icon } from "semantic-ui-react";

export const BookingCard = ({ header, content, iconName }) => {
  return (
    <div
      style={{
        width: "85%",
        margin: "0 auto",
        textAlign: "center",
        padding: "9px 0 18px 0"
      }}
    >
      <Icon bordered circular name={iconName} size="large" />
      <h3 style={{ marginTop: "2px" }}>{header}</h3>
      <p>{content}</p>
    </div>
  );
};

export default BookingCard;



// WEBPACK FOOTER //
// ./src/components/Booking/FormContainer/BookingCard.jsx